import i18n from "../i18n";
import * as Yup from "yup";

export const OfficeAccessAuthorizationSchema = Yup.object({
  name: Yup.string().required(
    i18n.language === "en"
      ? "Name is required."
      : "الاسم مطلوب."
  ),

  department: Yup.string().required(
    i18n.language === "en"
      ? "Department is required."
      : "القسم مطلوب."
  ),

  mobileNo: Yup.string()
    .required(
      i18n.language === "en"
        ? "Mobile number is required."
        : "رقم الجوال مطلوب."
    )
    .matches(
      /^\d{1,14}$/,
      i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
    ),

  employeeNumber: Yup.string().required(
    i18n.language === "en"
      ? "Employee number is required."
      : "رقم الموظف مطلوب."
  ),

  officeNumber: Yup.string().required(
    i18n.language === "en"
      ? "Office number is required."
      : "رقم المكتب مطلوب."
  ),
});
